import { useEffect, useState } from 'react'
import { usePartnerContext } from '../../../utils/contexts/partner/PartnerContext.hooks'
import { PartnerType } from '../../../exports/utils'
import clientEnv from '../../../utils/global/clientEnv'
import { detectUserRegion, getLocalizedLegalLinks } from '../../../components/privacy-compliance'

// Builds the links for the help menu. Note: no Partner Status link — the System
// Status page is reached via Settings → Platform management instead of the help
// menu.
export type TdsHelpMenuLink = {
  href?: string
  messageId: string
  onClick?: () => void
}

export const useTdsHelpMenuLinks = () => {
  const partnerContext = usePartnerContext()

  const [legalLinks, setLegalLinks] = useState(() => getLocalizedLegalLinks(null))

  useEffect(() => {
    const updateLegalLinks = async () => {
      const region = await detectUserRegion()
      const localizedLinks = getLocalizedLegalLinks(region.countryCode)
      setLegalLinks(localizedLinks)
    }

    void updateLegalLinks()
  }, [])

  const docsUrl =
    partnerContext.partnerType === PartnerType.IDP
      ? 'https://docs.instacart.com/developer_platform_api/'
      : clientEnv.PUBLIC_CLIENT_PARTNER_DOCS_URL

  const termsUrl =
    partnerContext.partnerType === PartnerType.IDP
      ? 'https://docs.instacart.com/developer_platform_api/guide/terms_and_policies/developer_terms/'
      : legalLinks.termsUrl

  const links: TdsHelpMenuLink[] = [
    { href: docsUrl, messageId: 'navV2.userSettings.documentation' },
    { href: 'https://instacart.com/press', messageId: 'press' },
    { href: legalLinks.privacyUrl, messageId: 'privacy' },
    { href: 'https://instacart.safebase.us/', messageId: 'security_and_trust' },
    { href: termsUrl, messageId: 'terms' },
    {
      href: 'https://instacart.atlassian.net/servicedesk/customer/portal/1',
      messageId: 'service_desk',
    },
  ]

  return links
}
